import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {CatalogService} from '../catalogue/catalog-api/catalog.service';
import {JwtHelper} from 'angular2-jwt';
import {BulkInfohashService} from './bulk-infohash.service';
import {ToasterService} from 'angular2-toaster';
import {UserDetailsService} from '../shared/user.details.service';
import {TitleSearchBox} from '../shared/title-search-box/title.search.box.component';
import {async} from 'rxjs/scheduler/async';

const PAGE_SIZE = 100;

interface PendingMappingRequest {
    idUpdatingUser: string;
    idMappingRequest: number;
    state: 'approved' | 'rejected';
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'bulk-infohash',
    templateUrl: 'bulk-infohash.component.html',
    styleUrls: ['bulk-infohash.component.scss']
})
export class BulkInfohashComponent implements OnInit {

    @Input() selectedShowParrotID;

    private tableData: any = null;
    private parrotIDList: any = null;

    private navIndex = 1;

    private totalNumberOfTorrents = 0;

    private totalNumberOfTorrentsCleared = 0;


    private maxDate = new Date();
    private maxPages;
    private loadingInfohashes = false;
    private redirectInfohash = '';
    private jwtAuthorityClaims = [];
    private decoder = new JwtHelper();
    private adminMode = false;
    private selectAll = false;

    // Variables to be used for query
    private infohashType: number = 3;
    private categoryType: number = 0;

    private dateRangeItem: string = 'date_discovered';
    private orderBy: string = 'trackedOn';
    private categoryTypeEditChange = 'tv';
    private searchByValue: string = 'searchby_title';
    private orderDirection;
    private startDate = new Date();
    private endDate = new Date();
    private page = 1;
    private placeHolderValue = '';

    private searchText = '';
    private searchType: 'exact' | 'like' = 'exact';
    private searchItems = [];

    private advancedMode = true;
    private isAdmin = false;

    private unmappedInfohashedCheck = false;
    private dailyMappingCheck = false;
    private searchByTitleCheck = true;
    private searchByParrotIdCheck = false;
    private searchByInfohashCheck = false;

    private allInfohashCheck = false;
    private activeMovieInfohashCheck = true;
    private dailyInfoHashCheck = false;
    private tvSeriesCheck: boolean;
    private moviesCheck: boolean;

    private humanVerifiedCheck = false;
    private systemVerifiedCheck = false;
    private torrentAvailableCheck = false;
    private categoryValue = ['tv'];
    private esIndexValue = 'tv';
    private humanVerifiedTorrents: any;
    private totalTorrents: any;

    private editMode = false;
    private selectedInfohash: any;
    private editTitleValue: string;
    private editParrotIDValue: string;
    private editReleaseYearValue: string;
    private editSeasonValue: string;
    private editEpisodeValue: string;
    private humanVerfiedCheckBox = false;
    private systemVerfiedCheckBox = false;
    private smartGroupingCheckBox = true;
    private parrotIDOnlyCheckBox = true;
    private demandOnlyCheckBox = true;

    private humanVerfied = [false];
    private systemVerfied = [false, true];

    @ViewChild('titleSearchBox') titleSearchBoxInput;
    @ViewChild('smartGroupingTitleSearchBox') smartGroupingTitleSearchBoxInput;


    private UPDATE_PROPERTIES_JSON = {
        'property': '',
        'property_value': ''
    };

    constructor(private catalogService: CatalogService,
                private bulkInfohashService: BulkInfohashService,
                private toasterService: ToasterService,
                private userDetailsService: UserDetailsService) {

    }

    handleNavSelect(index) {
        this.navIndex = index;
    }
    // ngAfterViewInit(): void {
    //
    // }

    // tslint:disable-next-line:member-ordering
    public pieChartLabels: string[] = ['movie', 'music', 'others', 'porn', 'tv'];
    // tslint:disable-next-line:member-ordering
    public pieChartData: number[] = [600708, 27947, 1227607, 12335, 1021088];
    // tslint:disable-next-line:member-ordering
    public pieChartType: string = 'pie';

    // tslint:disable-next-line:member-ordering
    pieChartColor: any = [
        {
            backgroundColor: ['rgba(30, 169, 224, 0.8)',
                'rgba(255,165,0,0.9)',
                'rgba(139, 136, 136, 0.9)',
                'rgba(255, 161, 181, 0.9)',
                'rgba(255, 102, 0, 0.9)'
            ]
        }
    ];

    // tslint:disable-next-line:member-ordering
    private checkboxes = {
        tv: true,
        movie: false,
        smartgrouped: true,
        parrotIDOnly: true,
        demandOnly: true,
        human_verified_true: false,
        human_verified_false: true,
        system_verified_true: true,
        system_verified_false: true,


    };


    // tslint:disable-next-line:member-ordering
    private sortNSearchCriteriaCheckboxes = {
        byDate: false,
        // byParrotid: false,
        // byTitle: false,
        sortState: true,
        sortDirection: true
    };

    onOriginalKeyUp(value, type) {
        switch (type) {
            case 'byParrotid':
                // this.byParrotIdSearch = value;
                break;
            case 'byTitle':
                // this.byTitleSearch = value;
                break;
            case 'byDate':
                break;
            case 'sortState':
                if (value) {
                    // 'Release Date', 'Total Number of Videos', 'Total Number of Views', 'Total Number of Unverified Videos'
                    if ( value === 'Tracking Date' ) {
                        value = 'trackedOn';
                    } else if ( value === 'Infohash' ) {
                        value = 'infohash';
                    } else if ( value === 'Hygiene Title' ) {
                        value = 'hygieneTitle';
                    } else if ( value === 'Parrot Id' ) {
                        value = 'parrotId';
                    }else if ( value === 'Discovery Date' ) {
                        value = 'discoveryTime';
                    }else if ( value === 'Cumulative Total Records' ) {
                        value = 'cumulativeTotalRecords';
                    }else if ( value === 'Seeders/Leechers' ) {
                        value = 'seedersAndLeechers';
                    }
                    this.orderBy = value;
                }
                break;
            case 'sortDirection':
                if (value) {
                    // 'Release Date', 'Total Number of Videos', 'Total Number of Views', 'Total Number of Unverified Videos'
                    if ( value === 'Ascending') {
                        value = 'asc';
                    } else if ( value === 'Descending' ) {
                        value = 'desc';
                    }
                    this.orderDirection = value;
                }
                break;
        }
    }

    handleOriginalFiltersCheckboxes(checkboxName) {
        this.sortNSearchCriteriaCheckboxes[checkboxName] = !this.sortNSearchCriteriaCheckboxes[checkboxName];
        // If a recently enabled checkbox has text, do a search.)
        // if (this.shouldSearch()) {
        //     switch (checkboxName) {
        //         case 'byParrotid':
        //             if (this.byParrotIdSearch && this.byParrotIdSearch !== '') {
        //                 this.shouldDoSearch = true;
        //             }
        //             break;
        //         case 'byTitle':
        //             if (this.byTitleSearch && this.byTitleSearch !== '') {
        //                 this.shouldDoSearch = true;
        //             }
        //             break;
        //         case 'country':
        //             if (this.originalCountry && this.originalCountry !== '') {
        //                 this.shouldDoSearch = true;
        //             }
        //             break;
        //         case 'catalogState':
        //             if (this.sortByState && this.sortByState !== '') {
        //                 this.shouldDoSearch = true;
        //             }
        //             break;
        //     }
        // } else {
        //     // If all filters are disabled, set the table data to empty
        //     this.results = [];
        // }
    }

    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }

    ngOnInit() {
        this.startDate = new Date('2020-09-06');
        this.isAdmin = this.userDetailsService.isAdmin();
        this.orderBy = 'trackedOn';
        this.categoryTypeEditChange = 'tv';
        this.orderDirection = 'desc';

        if (this.selectedShowParrotID) {
            //console.log(this.selectedShowParrotID);
            this.navIndex = 1;
            this.searchByParrotIdCheck = true;
            this.searchText = this.selectedShowParrotID;
            this.handleSearchInfohashes();
        }

    }

    public onHumanVerfiedCheck(value) {
        // this.humanVerfiedCheckBox = value;
        // // console.log(this.humanVerfiedCheckBox);
        // if (value) {
        //     this.humanVerfiedCheckBox = true;
        // } else {
        //     this.humanVerfiedCheckBox = false;
        // }

        // this.smartGroupingCheckBox = value;
        // console.log(this.humanVerfiedCheckBox);

        // console.log(value)

        this.humanVerfied = value;

        // this.categoryType = value;
        this.tableData = null;
    }

    public onSmartGroupingCheck(value) {
        // this.smartGroupingCheckBox = value;
        // console.log(this.humanVerfiedCheckBox);
        if (value) {
            this.smartGroupingCheckBox = true;
        } else {
            this.smartGroupingCheckBox = false;
        }
    }

    public onParrotIDOnlyCheck(value) {
        // this.smartGroupingCheckBox = value;
        // console.log(this.humanVerfiedCheckBox);

        // console.log(value)

        if (value) {
            this.parrotIDOnlyCheckBox = true;
        } else {
            // console.log(value);
            this.parrotIDOnlyCheckBox = false;
        }
    }

    public onDemandSupplyOnly(value) {

        if (value) {
            this.demandOnlyCheckBox = true;
        } else {
            // console.log(value);
            this.demandOnlyCheckBox = false;
        }
    }

    public onSystemVerfiedCheck(value) {
        // this.systemVerfiedCheckBox = value;
        // // console.log(this.systemVerfiedCheckBox);
        // if (value) {
        //     this.systemVerfiedCheckBox = true;
        // } else {
        //     this.systemVerfiedCheckBox = false;
        // }

        // console.log(value)

        this.systemVerfied = value;

        // this.categoryType = value;
        this.tableData = null;

    }

    onCategoryTypeChange(value: any) {
        // if (value === 0 || value === 1) {
        //     this.searchText = '';
        //     this.searchItems = [];
        // }
        //
        // if (value === 0) {
        //     this.tvSeriesCheck = true;
        //     this.categoryValue = 'tv';
        // }
        // if (value === 1) {
        //     this.moviesCheck = true;
        // }

        // console.log(value)

        this.categoryValue = value;

        this.categoryType = value;
        this.tableData = null;
    }


    onInfohashTypeChange(value: number) {

        this.categoryValue = ['tv'];

        if (value === 0 || value === 1) {
            this.searchText = '';
            this.searchItems = [];

        }
        if (value === 1) {
            this.allInfohashCheck = false;
            this.searchByTitleCheck = true;
            this.dailyInfoHashCheck = false;
            this.smartGroupingCheckBox = false;
            this.activeMovieInfohashCheck = false;

        }
        if (value === 0) {
            // this.unmappedInfohashedCheck = true;
            this.allInfohashCheck = true;
            this.searchByInfohashCheck = false;
            this.searchByParrotIdCheck = false;
            this.searchByTitleCheck = false;
            this.dailyInfoHashCheck = false;
            this.activeMovieInfohashCheck = false;

        }
        if (value === 2) {
            // this.unmappedInfohashedCheck = true;
            this.allInfohashCheck = true;
            this.searchByInfohashCheck = false;
            this.searchByParrotIdCheck = false;
            this.searchByTitleCheck = false;
            this.dailyInfoHashCheck = true;
            this.smartGroupingCheckBox = false;
            this.activeMovieInfohashCheck = false;

        }
        if (value === 3) {
            // this.unmappedInfohashedCheck = true;
            this.allInfohashCheck = false;
            this.searchByInfohashCheck = false;
            this.searchByParrotIdCheck = false;
            this.searchByTitleCheck = false;
            this.dailyInfoHashCheck = true;
            this.smartGroupingCheckBox = false;
            this.activeMovieInfohashCheck = true;
            this.categoryValue = ['movie']
        }


        this.infohashType = value;
        this.tableData = null;
    }

    onDateRangeItemChange(event: any) {
        this.dateRangeItem = event;
    }

    onOrderByChange(event: any) {
        this.orderBy = event;
    }

    onCategoryTypeEditChange(event: any) {

        this.categoryTypeEditChange = event;
    }

    onSearchByValueChange(event: any) {
        // console.log(event);
        this.searchText = '';
        this.searchByValue = event;

        if (this.searchByValue === 'searchby_title') {
            this.placeHolderValue = 'Search by title';
            this.searchByTitleCheck = true;
            this.searchByInfohashCheck = false;
            this.searchByParrotIdCheck = false;

        } else if (this.searchByValue === 'searchby_parrotid') {
            this.placeHolderValue = 'Search by Parrot ID';
            this.searchByParrotIdCheck = true;
            this.searchByTitleCheck = false;
            this.searchByInfohashCheck = false;


        } else if (this.searchByValue === 'searchby_infohash') {
            this.placeHolderValue = 'Search by Infohash';
            this.searchByInfohashCheck = true;
            this.searchByTitleCheck = false;
            this.searchByParrotIdCheck = false;


        }

    }

    onOrderDirectionChange(event: any) {
        this.orderDirection = event;
    }

    handleEdit(data) {
        this.redirectInfohash = data.infohash;
        this.selectedInfohash = data.infohash;
        this.editMode = true;

        this.editTitleValue = undefined;
        this.editParrotIDValue = undefined;
        this.editSeasonValue = undefined;
        this.editEpisodeValue = undefined;
        this.categoryTypeEditChange = data.category;
        this.editReleaseYearValue = undefined;
    }

    private sortValues = ['Tracking Date', 'Infohash', 'Hygiene Title', 'Parrot Id', 'Discovery Date', 'Cumulative Total Records'];
    private sortDirectionValues = ['Descending', 'Ascending'];

    handleApprove(data) {

        if (!this.adminMode && !(data.parrot_id || data.title)) {
            this.toasterService.pop('error', 'Cannot approve a title with no current parrot id');
        } else {
            data.action = 'approved';

            if (this.smartGroupingCheckBox) {


                this.parrotIDList.forEach((parrotID) => {
                    parrotID.torrents.forEach((item) => {
                        if (item.selected) {
                            item.action = 'approved';
                            item.selected = false;
                            // item.human_verified = true;

                            if (this.selectAll) {
                                item.infohash = item.infohash;
                            } else {
                                item.infohash = item.infohash;
                            }
                        }
                    });
                });

            } else {
                this.tableData.forEach((item) => {
                    if (item.selected) {
                        item.action = 'approved';
                        item.selected = false;
                        // item.human_verified = true;

                        if (this.selectAll) {
                            item.infohash = item.infohash;
                        } else {
                            item.infohash = item.infohash;
                        }
                    }
                });
            }
        }
        this.selectAll = false;

    }

    handleReject(data) {
        data.action = 'rejected';
        if (this.smartGroupingCheckBox) {


            this.parrotIDList.forEach((parrotID) => {
                parrotID.torrents.forEach((item) => {
                    if (item.selected) {
                        item.action = 'rejected';
                        item.selected = false;
                        item.redirectParrotId = '';
                        // item.human_verified = true;
                        if (this.selectAll) {
                            item.infohash = item.infohash;
                        } else {
                            item.infohash = item.infohash;
                        }
                    }
                });
            });

        } else {
            this.tableData.forEach((item) => {
                if (item.selected) {
                    item.action = 'rejected';
                    item.selected = false;
                    item.redirectParrotId = '';
                    // item.human_verified = true;
                    if (this.selectAll) {
                        item.infohash = item.infohash;
                    } else {
                        item.infohash = item.infohash;
                    }
                }
            });
        }
        this.selectAll = false;
    }

    handleCancelEdit() {
        this.redirectInfohash = '';
        this.editMode = false;
    }

    handleInputClick(title) {
        if (this.smartGroupingCheckBox) {
            (this.smartGroupingTitleSearchBoxInput as TitleSearchBox).onKeyUp(title);
        }
        // tslint:disable-next-line:one-line
        else{
            (this.titleSearchBoxInput as TitleSearchBox).onKeyUp(title);
        }
    }

    handleSmartGroupingInputClick(title) {
        (this.smartGroupingTitleSearchBoxInput as TitleSearchBox).onKeyUp(title);
    }

    handleTitleSelect(event, data) {
        this.editTitleValue = event[1];
        this.editParrotIDValue = event[0];
        this.editReleaseYearValue = event[2];
        this.redirectInfohash = '';

        if (this.smartGroupingCheckBox) {


            this.parrotIDList.forEach((parrotID) => {
                parrotID.torrents.forEach((item) => {

                    if (item.selected) {

                        item.action = 'redirect';
                        // console.log("value here");
                        // console.log(event[0]);
                        item.redirectParrotId = event[0];
                        item.redirectDisplayName = event[1];
                        item.redirectSeasonValue = this.editSeasonValue;
                        item.redirectEpisodeValue = this.editEpisodeValue;
                        item.redirectCategoryValue = this.categoryTypeEditChange;
                        item.releaseValue = this.editReleaseYearValue;
                        item.redirectHumanVerified = true;
                        if (this.selectAll) {
                            item.infohash = item.infohash;
                        } else {
                            item.infohash = item.infohash;
                        }

                        item.selected = false;

                    }
                });
            });

        } else {


            this.tableData.forEach((item) => {
                if (item.selected) {
                    item.action = 'redirect';
                    item.redirectParrotId = event[0];
                    item.redirectDisplayName = event[1];
                    item.redirectSeasonValue = this.editSeasonValue;
                    item.redirectEpisodeValue = this.editEpisodeValue;
                    item.redirectCategoryValue = this.categoryTypeEditChange;
                    item.releaseValue = this.editReleaseYearValue;
                    item.redirectHumanVerified = true;
                    if (this.selectAll) {
                        item.infohash = item.infohash;
                    } else {
                        item.infohash = item.infohash;
                    }

                    item.selected = false;
                }
            });
        }
        data.action = 'redirect';
        data.redirectParrotId = event[0];
        data.redirectDisplayName = event[1];
        data.redirectSeasonValue = this.editSeasonValue;
        data.redirectEpisodeValue = this.editEpisodeValue;
        data.redirectCategoryValue = this.categoryTypeEditChange;
        data.releaseValue = this.editReleaseYearValue;
        data.redirectHumanVerified = true;
        this.selectAll = false;
    }

    handleCancelAction(data) {
        data.action = undefined;

        if (this.smartGroupingCheckBox) {


            this.parrotIDList.forEach((parrotID) => {
                parrotID.torrents.forEach((item) => {
                    // if (item.selected) {
                    item.action = undefined;
                    item.selected = false;

                    item.parrot_id = data.parrot_id;
                    item.redirectDisplayName = data.title;
                    item.redirectSeasonValue = data.season;
                    item.redirectEpisodeValue = data.episode;
                    item.redirectCategoryValue = data.category;
                    item.releaseValue = data.release_year;
                    item.human_verified = data.human_verified;


                    // }
                });
            });

        } else {

            this.tableData.forEach((item) => {

                // console.log(item)
                // console.log(data)

                if (item.selected) {
                    item.action = undefined;
                    item.selected = false;

                    item.parrot_id = data.parrot_id;
                    item.redirectDisplayName = data.title;
                    item.redirectSeasonValue = data.season;
                    item.redirectEpisodeValue = data.episode;
                    item.redirectCategoryValue = data.category;
                    item.releaseValue = data.release_year;
                    item.human_verified = data.human_verified;


                }
            });
        }
        this.handleCancelEdit();
        this.selectAll = false;
    }

    handleAdminMode() {
        this.tableData = undefined;
        this.adminMode = !this.adminMode;
        // console.log(this.adminMode);
        // Set the sort by to the default for the mode
        if (this.adminMode) {
            this.orderBy = 'trackedOn';
        } else {
            this.orderBy = 'trackedOn';
            this.categoryTypeEditChange = 'tv';

        }
        this.searchItems = [];
        this.searchText = '';
    }

    handleAdvancedMode() {
        if (this.loadingInfohashes) {
            this.toasterService.pop('info', 'Please wait until the current request is done!');
        } else {
            this.tableData = undefined;
            this.adminMode = false;
            this.orderBy = 'trackedOn';
            this.categoryTypeEditChange = 'tv';
            this.advancedMode = !this.advancedMode;
        }
    }

    handleGoToPage(page) {
        // if (this.hasSelectedTitle()) {
        //     this.toasterService.pop('info', 'Please either clear or submit the current page before going to another');
        //     return;
        // }
        this.selectAll = false;
        this.page = page;
        this.searchInfohashes();
    }

    handleNextPage() {
        this.handleGoToPage(this.page + 1);
    }

    handlePreviousPage() {
        this.handleGoToPage(this.page - 1);
    }

    handleFirstPage() {
        this.handleGoToPage(1);
    }

    handleLastPage() {
        this.handleGoToPage(this.maxPages);
    }

    handleClear() {
        this.tableData = this.tableData.map((item) => {
            item.action = undefined;
            item.selected = false;
            item.parrot_id = item.parrot_id;
            item.title = item.title;
            item.season = item.season;
            item.episode = item.episode;
            item.category = item.category;
            item.release_year = item.release_year;
            item.human_verified = item.human_verified;
            return item;
        });

        this.handleCancelEdit();
    }

    handleSelected(data) {
        this.selectAll = false;
        // console.log(data);
        this.selectedInfohash = data.infohash;
        data.selected = !data.selected;
    }

    handleRejected(data) {
        this.selectAll = false;
        // console.log(data);
        this.selectedInfohash = data.infohash;
        data.selected = !data.selected;
    }

    handleSelectAll() {
        this.selectAll = !this.selectAll;
        this.tableData = this.tableData.map((item) => {
            item.selected = this.selectAll;
            return item;
        });
    }

    handleSmartGroupingSelectAll(parrotId) {

        this.selectAll = !this.selectAll;

        this.parrotIDList = this.parrotIDList.map((item) => {

            item.torrents = item.torrents.map((data) => {
                // console.log(parrotId.parrotId);
                // console.log(data.parrot_id);

                if (parrotId.parrotId === data.parrot_id) {
                    data.selected = this.selectAll;
                }

                return data;
            });
            return item;
        });
    }

    handleSearchInfohashes() {
        this.page = 1;
        this.searchInfohashes();
    }

    handleTitleEdit() {
        this.editTitleValue = '';
        this.searchText = '';
        // console.log(this.searchText);
        if (!this.searchItems.includes(this.searchText)) {
            if (![0, 4].includes(this.infohashType)) {
                this.searchItems.push(this.searchText);
                this.searchText = '';
            }
        } else {
            this.toasterService.pop('info', 'Cannot insert duplicate entry');
        }
    }

    handleParrotIDEdit() {
        this.editParrotIDValue = '';

        this.searchText = '';
        // console.log(this.searchText);
        if (!this.searchItems.includes(this.searchText)) {
            if (![0, 4].includes(this.infohashType)) {
                this.searchItems.push(this.searchText);
                this.searchText = '';
            }
        } else {
            this.toasterService.pop('info', 'Cannot insert duplicate entry');
        }
    }

    handleReleaseYearEdit() {
        this.editReleaseYearValue = '';

        this.searchText = '';
        // console.log(this.searchText);
        if (!this.searchItems.includes(this.searchText)) {
            if (![0, 4].includes(this.infohashType)) {
                this.searchItems.push(this.searchText);
                this.searchText = '';
            }
        } else {
            this.toasterService.pop('info', 'Cannot insert duplicate entry');
        }
    }

    handleSeasonEdit() {
        this.editSeasonValue = '';

        this.searchText = '';
        // console.log(this.searchText);
        if (!this.searchItems.includes(this.searchText)) {
            if (![0, 4].includes(this.infohashType)) {
                this.searchItems.push(this.searchText);
                this.searchText = '';
            }
        } else {
            this.toasterService.pop('info', 'Cannot insert duplicate entry');
        }
    }

    handleEpisodeEdit() {
        this.editEpisodeValue = '';

        this.searchText = '';
        // console.log(this.searchText);
        if (!this.searchItems.includes(this.searchText)) {
            if (![0, 4].includes(this.infohashType)) {
                this.searchItems.push(this.searchText);
                this.searchText = '';
            }
        } else {
            this.toasterService.pop('info', 'Cannot insert duplicate entry');
        }
    }


    handleSubmitParrotId() {
        this.searchText = '';
        // console.log(this.searchText);
        if (!this.searchItems.includes(this.searchText)) {
            if (![0, 4].includes(this.infohashType)) {
                this.searchItems.push(this.searchText);
                this.searchText = '';
            }
        } else {
            this.toasterService.pop('info', 'Cannot insert duplicate entry');
        }
    }

    handleTitleSearchSelect($event) {
        // console.log($event);
        if (!this.searchItems.includes($event[0])) {
            this.searchItems.push($event[0]);
            this.searchText = $event[1];
        } else {
            this.toasterService.pop('info', 'Cannot insert duplicate entry');
        }
    }

    handleRemoveSearchItem(searchItem) {
        this.searchItems = this.searchItems.filter(item => item !== searchItem);
    }

    handleSearchTypeSelect(type) {
        if ((type === 'exact' || type === 'like')) {
            this.searchType = type;
        }
    }

    hasSelectedTitle() {
        return this.tableData.find((item) => item.action);
    }

    handleSubmit() {
        this.loadingInfohashes = true;
        this.selectAll = false;
        if (!this.smartGroupingCheckBox) {
            const actionsArray = this.tableData.filter((item) => {
                return item.action;
            });

            if (actionsArray.length === 0) {
                this.toasterService.pop('info', 'There are no actions to submit!');
                this.loadingInfohashes = false;
                return;
            }
        } else {
            const actionsArray = [];
            for (let i = 0; i < this.parrotIDList.length; i++) {
                this.parrotIDList[i].torrents.filter((item) => {
                    actionsArray.push(item.action);
                });
            }

            if (actionsArray.length === 0) {
                this.toasterService.pop('info', 'There are no actions to submit!');
                this.loadingInfohashes = false;
                return;
            }
        }

        if (this.adminMode) {
            const requestBody = this.tableData.filter((item) => {
                return item.action;
            }).map((item) => {
                return {
                    idUpdatingUser: this.userDetailsService.getCachedUserName(),
                    idMappingRequest: item.idMappingRequest,
                    state: item.action
                } as PendingMappingRequest;
            });
            this.tableData = undefined;

            const user = this.advancedMode ? null : this.userDetailsService.getUsername();
            // console.log(requestBody);
            this.bulkInfohashService.postProcessMappings(requestBody, user)
                .then((res) => {
                    this.loadingInfohashes = false;
                    this.toasterService.pop('success', `Successfully processed update requests for ${requestBody.length} mappings!`);
                })
                .catch((err) => {
                    this.loadingInfohashes = false;
                    console.error('Failed to process update requests: ', err.toString());
                    this.toasterService.pop('error', 'Failed to process update requests');
                });
        } else {

            const updateArray = [];

            if (this.smartGroupingCheckBox) {
                for (let i = 0; i < this.parrotIDList.length; i++) {
                    const requestBody = this.parrotIDList[i].torrents.filter((item) => {
                        // console.log(item);
                        return item.action;
                    }).map((item) => {
                        let newTitleId = '';
                        if (item.action === 'approved') {
                            const individualApprovedUpdateObject = this.approvedUpdateObject(item);
                            updateArray.push(individualApprovedUpdateObject);

                        } else if (item.action === 'rejected') {
                            const individualRejectedUpdateObject = this.approvedRejectObject(item);

                            updateArray.push(individualRejectedUpdateObject);

                            newTitleId = '';
                        } else if (item.action === 'redirect') {
                            const individualRedirectedUpdateObject = this.approvedRedirectedObject(item);
                            const finalObject = {
                                'infohash': item.infohash,
                                'properties':
                                individualRedirectedUpdateObject

                            };

                            updateArray.push(finalObject);

                            newTitleId = item.redirectParrotId;
                        }
                        return {
                            infohash: item.infohash,
                            idRequestUser: this.userDetailsService.getCachedUserName(),
                            titleId: item.currentParrotId ? item.currentParrotId : '',
                            title: item.localTitle,
                            newTitleId
                        };
                    });
                }


            } else {

                const requestBody = this.tableData.filter((item) => {
                    // console.log(item);
                    return item.action;
                }).map((item) => {
                    let newTitleId = '';
                    if (item.action === 'approved') {
                        const individualApprovedUpdateObject = this.approvedUpdateObject(item);
                        updateArray.push(individualApprovedUpdateObject);

                    } else if (item.action === 'rejected') {
                        const individualRejectedUpdateObject = this.approvedRejectObject(item);

                        updateArray.push(individualRejectedUpdateObject);

                        newTitleId = '';
                    } else if (item.action === 'redirect') {
                        const individualRedirectedUpdateObject = this.approvedRedirectedObject(item);
                        const finalObject = {
                            'infohash': item.infohash,
                            'properties':
                            individualRedirectedUpdateObject

                        };

                        updateArray.push(finalObject);

                        newTitleId = item.redirectParrotId;
                    }
                    return {
                        infohash: item.infohash,
                        idRequestUser: this.userDetailsService.getCachedUserName(),
                        titleId: item.currentParrotId ? item.currentParrotId : '',
                        title: item.localTitle,
                        newTitleId
                    };
                });
            }
            this.tableData = undefined;
            // console.log(requestBody);
            const user = this.advancedMode ? null : this.userDetailsService.getUsername();
            const searchTermUrl = 'update_torrents';

            this.bulkInfohashService.updateInfohash(updateArray, searchTermUrl)
                .then((res) => {
                    if (res) {

                        // console.log(res);
                        // console.log(updateArray.length);
                        this.toasterService.pop('info', 'Mapping successfully updated');
                        if (updateArray.length === 100) {
                            this.handleNextPage();
                        } else {
                            this.stayInSamePageIfFailed(this.page);
                        }
                        this.loadingInfohashes = false;
                    } else {
                        this.stayInSamePageIfFailed(this.page);

                        this.loadingInfohashes = false;
                        this.toasterService.pop('error', 'Cannot update the selected mapping');
                    }
                })
                .catch((err) => {
                    this.stayInSamePageIfFailed(this.page);

                    this.toasterService.pop('error', 'Cannot update the selected mapping');
                    console.error('Error updating the infohash: ', err.toString());
                    this.loadingInfohashes = false;
                });

            // this.bulkInfohashService.postUpdateMappings(requestBody, user)
            //     .then((res) => {
            //         this.loadingInfohashes = false;
            //         this.toasterService.pop('success', `Successfully created an update request for ${requestBody.length} mappings!`);
            //     })
            //     .catch((err) => {
            //         this.loadingInfohashes = false;
            //         console.error('Failed to create update requests: ', err.toString());
            //         this.toasterService.pop('error', 'Failed to create update requests');
            //     });
        }
    }

    stayInSamePageIfFailed(page) {
        this.selectAll = false;
        this.page = page;
        this.searchInfohashes();
    }

    approvedRedirectedObject(data) {

        // console.log(data);
        //
        // console.log(this.editTitleValue);
        // console.log(this.editSeasonValue);
        // console.log(this.editEpisodeValue);
        // console.log(this.editParrotIDValue);
        // console.log(this.editReleaseYearValue);
        // console.log(this.categoryTypeEditChange);

        const propertiesArray = [];

        data.human_verified = true;
        data.infohash = data.infohash;

        if (data.redirectDisplayName) {
            propertiesArray.push({
                'property': 'title',
                'property_value': data.redirectDisplayName
            });
        }

        if (data.redirectSeasonValue) {
            propertiesArray.push({
                'property': 'season',
                'property_value': data.redirectSeasonValue
            });
        }

        if (data.redirectEpisodeValue) {
            propertiesArray.push({
                'property': 'episode',
                'property_value': data.redirectEpisodeValue
            });
        }

        if (data.redirectCategoryValue) {
            propertiesArray.push({
                'property': 'category',
                'property_value': data.redirectCategoryValue
            });
        }
        // console.log(data.redirectParrotId)  ;
        if (data.redirectParrotId) {
            propertiesArray.push({
                'property': 'parrot_id',
                'property_value': data.redirectParrotId
            });
        }

        if (data.releaseValue) {
            propertiesArray.push({
                'property': 'release_year',
                'property_value': data.releaseValue
            });
        }

        // console.log(propertiesArray);

        if (propertiesArray.length > 0) {

            propertiesArray.push({
                'property': 'human_verified',
                'property_value': true
            });
        }
        return propertiesArray;
    }

    approvedUpdateObject(data) {

        // console.log(this.editTitleValue);
        // console.log(this.editSeasonValue);
        // console.log(this.editEpisodeValue);
        // console.log(this.editParrotIDValue);
        // console.log(this.editReleaseYearValue);
        // console.log(this.categoryTypeEditChange);

        const propertiesArray = {
            'infohash': data.infohash,
            'properties': [
                {
                    'property': 'human_verified',
                    'property_value': true
                }
            ]
        };
        return propertiesArray;
    }


    approvedRejectObject(data) {

        // console.log(this.editTitleValue);
        // console.log(this.editSeasonValue);
        // console.log(this.editEpisodeValue);
        // console.log(this.editParrotIDValue);
        // console.log(this.editReleaseYearValue);
        // console.log(this.categoryTypeEditChange);

        const propertiesArray = {
            'infohash': data.infohash,
            'properties': [
                {
                    'property': 'parrot_id',
                    'property_value': '0'
                },

                {
                    'property': 'human_verified',
                    'property_value': true
                }
            ]
        };
        // console.log(propertiesArray);
        return propertiesArray;
    }


    infohashSearch() {
        // Figure out if its a daily check as the infohashType cannot be converted to a boolean
        // let dailyCheck = false;
        // let all = false;


        let searchTermUrl = 'torrent_search';
        let searchBy = 'titles';
        let esIndex = 'series_metadata';
        this.categoryValue = ['tv'];
        this.esIndexValue = 'tv';

        if (this.allInfohashCheck) {
            searchTermUrl = 'cumulative_torrents';
            this.searchByTitleCheck = false;
        }

        if (this.activeMovieInfohashCheck) {
            searchTermUrl = 'cumulative_torrents';
            this.searchByTitleCheck = false;
            this.categoryValue = ['movie'];
            this.esIndexValue = 'movie';
        }

        if (this.searchByParrotIdCheck) {
            searchTermUrl = 'torrent_search';
            searchBy = 'parrot_id';
        }

        if (this.searchByTitleCheck) {
            searchBy = 'titles';
            searchTermUrl = 'torrent_search';
        }

        if (this.searchByInfohashCheck) {
            searchBy = 'infohash';
            searchTermUrl = 'torrent_search';
        }

        if ( this.categoryValue.includes('movie')) {
            esIndex = 'movie_metadata';
        }

        if (!(searchTermUrl === 'cumulative_torrents')) {
            this.bulkInfohashService.getInfohashBySearchTerm(searchBy, this.searchText, this.page, PAGE_SIZE, searchTermUrl, this.orderBy, this.orderDirection)
                .then((res) => {
                    // console.log(res);
                    this.maxPages = res.pageInfo.maxpage ? res.pageInfo.maxpage : 1;
                    this.totalTorrents = res.pageInfo.totalitems ? res.pageInfo.totalitems : '';
                    // this.humanVerifiedTorrents = res.page_info.currentpdage ? res.page_info.currentdpage : '';

                    if ([4].includes(this.infohashType) && res.page_info.totalitems > 0) {
                        // If looking at daily mapping checks or searching by parrot ids, we want to get details about the current parrot id.
                        this.infohashGetESDetails(res.torrents);
                    } else {

                        this.tableData = res.torrents.map((item) => {
                            this.fetchParrotIDResult(item.parrot_id, esIndex).then((parrotIDResults) => {

                                if (parrotIDResults[0]) {
                                    item.catalog_state = parrotIDResults[0].catalogState;
                                    item.catalog_type = parrotIDResults[0].catalogType;
                                    item.displayName = parrotIDResults[0].displayName;
                                    item.original_network = parrotIDResults[0].originalNetwork;
                                    item.original_country = parrotIDResults[0].originalCountry;
                                    item.release_year = parrotIDResults[0].releaseYear;
                                } else {
                                    item.catalog_state = 'N/A';
                                    item.catalog_state = 'N/A';
                                    item.catalog_type = 'N/A';
                                    item.displayName = 'N/A';
                                    item.original_network = 'N/A';
                                    item.original_country = 'N/A';
                                    item.release_year = 'N/A';
                                }

                                item.infohash = item.infohash ? item.infohash : 'N/A';
                                item.torrent_name = item.torrent_name ? item.torrent_name : 'N/A';
                                item.category = item.category ? item.category : 'N/A';
                                item.parrot_id = item.parrot_id ? item.parrot_id : 'N/A';

                                item.title = item.title ? item.title : 'N/A';
                                item.season = item.season ? item.season : 'N/A';
                                item.episode = item.episode ? item.episode : 'N/A';
                                item.hygiene_title = item.hygiene_title ? item.hygiene_title : 'N/A';
                                item.seeders_leechers = item.seeders_leechers ? item.seeders_leechers : 'N/A';
                                item.cumulative_total_records = item.cumulative_total_records ? item.cumulative_total_records : '0';
                                item.title_priority = item.title_priority ? item.title_priority : 'N/A';
                                item.torrent_priority = item.torrent_priority ? item.torrent_priority : 'N/A';
                                item.torrent_available = item.torrent_available ? item.torrent_available : 'N/A';
                                item.release_year = item.release_year ? item.release_year : 'N/A';

                                item.last_allocated_time = item.last_allocated_time ? new Date(item.last_allocated_time).toISOString().slice(0, 10) : '0000-00-00';
                                item.discovery_time = item.discovery_time ? new Date(item.discovery_time).toISOString().slice(0, 10) : '0000-00-00';
                                item.updated_time = item.updated_time ? new Date(item.updated_time).toISOString().slice(0, 10) : '0000-00-00';
                                item.last_searched_time = item.last_searched_time ? new Date(item.last_searched_time).toISOString().slice(0, 10) : '0000-00-00';
                                item.tracked_on = item.tracked_on ? new Date(item.tracked_on).toISOString().slice(0, 10) : '0000-00-00';

                                if (item.human_verified) {
                                    item.humanVerifiedText = 'Yes';
                                    this.humanVerifiedCheck = true;
                                } else {
                                    item.humanVerifiedText = 'No';
                                    this.humanVerifiedCheck = false;

                                }
                                if (item.system_verified) {
                                    item.systemVerifiedText = 'Yes';
                                    this.systemVerifiedCheck = true;

                                } else {
                                    item.systemVerifiedText = 'No';
                                    this.systemVerifiedCheck = false;

                                }
                                if (item.torrent_available) {
                                    item.torrent_available = 'Yes';
                                    this.torrentAvailableCheck = true;

                                } else {
                                    item.torrent_available = 'No';
                                    this.torrentAvailableCheck = false;

                                }
                                // console.log(item)
                                return item;
                            });
                            return item;

                        });
                        // console.log(this.tableData.length);
                        if (this.tableData.length === 0) {
                            this.toasterService.pop('info', 'No infohashes were found');
                        }
                        this.loadingInfohashes = false;
                    }
                })
                .catch((err) => {
                    console.error('Error searching for infohashes: ', err.toString());
                    this.loadingInfohashes = false;
                });
        } else {

            let initialDate = this.startDate;

            if (this.infohashType === 2) {
                const currentDate = new Date();
                // console.log(currentDate);
                initialDate = new Date(Date.now() - 864e5);
            }
            // tslint:disable-next-line:max-line-length
            // getAllInfoHash(startDate: any, endDate: any, searchTerm: string, orderBy: string , orderDirection: string, page: any, pageSize: any, categoryType: String, searchUrlTerm: string) {

            let pageSize = PAGE_SIZE;

            if (this.smartGroupingCheckBox) {
                pageSize = 10;
            }

            // console.log(this.parrotIDOnlyCheckBox)
            // tslint:disable-next-line:max-line-length
            this.bulkInfohashService.getAllInfoHash(initialDate, this.endDate, this.orderBy, this.orderDirection, this.page, pageSize, this.categoryValue, searchTermUrl, this.humanVerfied, this.systemVerfied, this.smartGroupingCheckBox, this.parrotIDOnlyCheckBox, this.demandOnlyCheckBox)
                .then((res) => {
                    // console.log(res);
                    this.totalTorrents = res.page_info.totalitems ? res.page_info.totalitems : '';
                    this.humanVerifiedTorrents = res.page_info.currentpdage ? res.page_info.currentdpage : '';

                    this.maxPages = res.page_info.maxpage ? res.page_info.maxpage : 1;

                    if ([4].includes(this.infohashType) && res.page_info.totalitems > 0) {
                        // If looking at daily mapping checks or searching by parrot ids, we want to get details about the current parrot id.
                        this.infohashGetESDetails(res.torrents);
                    } else {
                        if (res.torrents) {
                            this.tableData = res.torrents.map((item) => {

                                this.fetchParrotIDResult(item.parrot_id, esIndex).then((parrotIDResults) => {


                                    item.title = item.title ? item.title : 'N/A';
                                    item.season = item.season ? item.season : 'N/A';
                                    item.episode = item.episode ? item.episode : 'N/A';
                                    item.hygiene_title = item.hygiene_title ? item.hygiene_title : 'N/A';
                                    item.seeders_leechers = item.seeders_leechers ? item.seeders_leechers : 'N/A';
                                    item.cumulative_total_records = item.cumulative_total_records ? item.cumulative_total_records : '0';
                                    item.title_priority = item.title_priority ? item.title_priority : 'N/A';
                                    item.torrent_priority = item.torrent_priority ? item.torrent_priority : 'N/A';
                                    item.torrent_available = item.torrent_available ? item.torrent_available : 'N/A';
                                    item.release_year = item.release_year ? item.release_year : 'N/A';

                                    if (parrotIDResults[0]) {
                                        item.catalog_state = parrotIDResults[0].catalogState;
                                        item.catalog_type = parrotIDResults[0].catalogType;
                                        item.displayName = parrotIDResults[0].displayName;
                                        item.original_network = parrotIDResults[0].originalNetwork;
                                        item.original_country = parrotIDResults[0].originalCountry;
                                        item.release_year = parrotIDResults[0].releaseYear;
                                    } else {
                                        item.catalog_state = 'N/A';
                                        item.catalog_state = 'N/A';
                                        item.catalog_type = 'N/A';
                                        item.displayName = 'N/A';
                                        item.original_network = 'N/A';
                                        item.original_country = 'N/A';
                                        item.release_year = 'N/A';
                                    }

                                    if (item.displayName !== 'N/A') {
                                        item.title = item.displayName;
                                    }


                                    item.last_allocated_time = item.last_allocated_time ? new Date(item.last_allocated_time).toISOString().slice(0, 10) : '0000-00-00';
                                    item.discovery_time = item.discovery_time ? new Date(item.discovery_time).toISOString().slice(0, 10) : '0000-00-00';
                                    item.updated_time = item.updated_time ? new Date(item.updated_time).toISOString().slice(0, 10) : '0000-00-00';
                                    item.last_searched_time = item.last_searched_time ? new Date(item.last_searched_time).toISOString().slice(0, 10) : '0000-00-00';
                                    item.tracked_on = item.tracked_on ? new Date(item.tracked_on).toISOString().slice(0, 10) : '0000-00-00';

                                    if (item.human_verified) {
                                        item.humanVerifiedText = 'Yes';
                                        this.humanVerifiedCheck = true;
                                    } else {
                                        item.humanVerifiedText = 'No';
                                    }
                                    if (item.system_verified) {
                                        item.systemVerifiedText = 'Yes';
                                        this.systemVerifiedCheck = true;

                                    } else {
                                        item.systemVerifiedText = 'No';
                                    }
                                    if (item.torrent_available) {
                                        item.torrent_available = 'Yes';
                                        this.torrentAvailableCheck = true;

                                    } else {
                                        item.torrent_available = 'No';
                                    }

                                    return item;
                                });
                                return item;
                            });
                            // console.log(this.tableData.length);
                            if (this.tableData.length === 0) {
                                this.toasterService.pop('info', 'No infohashes were found');
                            }
                            this.loadingInfohashes = false;
                        } else {

                            this.totalNumberOfTorrentsCleared += this.totalNumberOfTorrents;
                            this.totalNumberOfTorrents = 0;

                            this.parrotIDList = res.grouped_torrents.map((parrotIDObject) => {
                                parrotIDObject.parrot_id = parrotIDObject.parrotId ? parrotIDObject.parrotId : 'N/A';

                                this.fetchParrotIDResult(parrotIDObject.parrot_id, esIndex).then((parrotIDResults) => {


                                    if (parrotIDResults[0]) {
                                        parrotIDObject.catalog_state = parrotIDResults[0].catalogState;
                                        parrotIDObject.catalog_type = parrotIDResults[0].catalogType;
                                        parrotIDObject.displayName = parrotIDResults[0].displayName;
                                        parrotIDObject.original_network = parrotIDResults[0].originalNetwork;
                                        parrotIDObject.release_year = parrotIDResults[0].releaseYear;
                                        parrotIDObject.original_country = parrotIDResults[0].originalCountry;
                                    } else {
                                        parrotIDObject.catalog_state = 'N/A';
                                        parrotIDObject.catalog_state = 'N/A';
                                        parrotIDObject.catalog_type = 'N/A';
                                        parrotIDObject.displayName = 'N/A';
                                        parrotIDObject.original_network = 'N/A';
                                        parrotIDObject.release_year = 'N/A';
                                    }


                                    parrotIDObject.totalCummulativeRecords = 0;

                                    parrotIDObject.totalSeedersLeechers = 0;

                                    parrotIDObject.categoryList = [];

                                    // tslint:disable-next-line:radix
                                    this.totalNumberOfTorrents += parseInt(parrotIDObject.torrents.length);

                                    parrotIDObject.torrents = parrotIDObject.torrents.map((item) => {

                                            item.infohash = item.infohash ? item.infohash : 'N/A';
                                            item.torrent_name = item.torrent_name ? item.torrent_name : 'N/A';
                                            item.category = item.category ? item.category : 'N/A';
                                            item.parrot_id = item.parrot_id ? item.parrot_id : 'N/A';
                                            item.title = item.title ? item.title : 'N/A';
                                            item.season = item.season ? item.season : 'N/A';
                                            item.episode = item.episode ? item.episode : 'N/A';
                                            item.hygiene_title = item.hygiene_title ? item.hygiene_title : 'N/A';
                                            item.seeders_leechers = item.seeders_leechers ? item.seeders_leechers : '0';
                                            // tslint:disable-next-line:radix
                                            parrotIDObject.totalSeedersLeechers += parseInt(item.seeders_leechers);
                                            item.cumulative_total_records = item.cumulative_total_records ? item.cumulative_total_records : '0';

                                            // tslint:disable-next-line:radix
                                            parrotIDObject.totalCummulativeRecords += parseInt(item.cumulative_total_records);
                                            item.title_priority = item.title_priority ? item.title_priority : 'N/A';
                                            item.torrent_priority = item.torrent_priority ? item.torrent_priority : 'N/A';
                                            item.torrent_available = item.torrent_available ? item.torrent_available : 'N/A';
                                            item.release_year = item.release_year ? item.release_year : 'N/A';

                                            // tslint:disable-next-line:one-line
                                            if (!parrotIDObject.categoryList.includes(item.category)) {
                                                parrotIDObject.categoryList.push(item.category);
                                            }

                                            item.last_allocated_time = item.last_allocated_time ? new Date(item.last_allocated_time).toISOString().slice(0, 10) : '0000-00-00';
                                            item.discovery_time = item.discovery_time ? new Date(item.discovery_time).toISOString().slice(0, 10) : '0000-00-00';
                                            item.updated_time = item.updated_time ? new Date(item.updated_time).toISOString().slice(0, 10) : '0000-00-00';
                                            item.last_searched_time = item.last_searched_time ? new Date(item.last_searched_time).toISOString().slice(0, 10) : '0000-00-00';
                                            item.tracked_on = item.tracked_on ? new Date(item.tracked_on).toISOString().slice(0, 10) : '0000-00-00';

                                            if (item.human_verified) {
                                                item.humanVerifiedText = 'Yes';
                                                this.humanVerifiedCheck = true;
                                            } else {
                                                item.humanVerifiedText = 'No';
                                            }
                                            if (item.system_verified) {
                                                item.systemVerifiedText = 'Yes';
                                                this.systemVerifiedCheck = true;

                                            } else {
                                                item.systemVerifiedText = 'No';
                                            }
                                            if (item.torrent_available) {
                                                item.torrent_available = 'Yes';
                                                this.torrentAvailableCheck = true;

                                            } else {
                                                item.torrent_available = 'No';
                                            }

                                            // console.log(item)
                                            return item;


                                        }
                                    ).sort((a, b) => {

                                        if (a.tracked_on < b.tracked_on) {
                                            return 1;
                                        }
                                        if (a.tracked_on > b.tracked_on) {
                                            return -1;
                                        }
                                        return 0;
                                    });
                                    // console.log(test);


                                    return parrotIDObject;
                                });
                                // return this.itemMapping(item);
                                return parrotIDObject;
                            });
                            // }

                            // console.log(this.parrotIDList);
                            if (this.parrotIDList.length === 0) {
                                this.toasterService.pop('info', 'No infohashes were found');
                            }
                            this.loadingInfohashes = false;
                        }
                    }
                })
                .catch((err) => {
                    console.error('Error searching for infohashes: ', err.toString());
                    this.loadingInfohashes = false;
                });
        }
    }

    private fetchParrotIDResult(parrot_id, esIndex) {

        let parrotIDResult = [];

        const queryJSON = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'term': {
                                'parrot_id': parrot_id
                            }
                        }
                    ]
                }
            }
        };

        return this.catalogService.callEsProxybasedOnParrotIDQuery(
            JSON.stringify(queryJSON),
            esIndex
        ).then((parrotIDResults) => {
            parrotIDResult = parrotIDResult.concat(parrotIDResults.hits.hits.map(this.catalogService.mapGlobalSearchEsResultItem));
            // console.log("test in title");
            return parrotIDResult;

        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
        });

    }

    // private itemMapping(item) {
    //
    //     return this.fetchParrotIDResult(item.parrot_id).then((parrotIDResults) => {
    //
    //         item.title = item.title ? item.title : 'N/A';
    //         item.season = item.season ? item.season : 'N/A';
    //         item.episode = item.episode ? item.episode : 'N/A';
    //         item.hygiene_title = item.hygiene_title ? item.hygiene_title : 'N/A';
    //         item.seeders_leechers = item.seeders_leechers ? item.seeders_leechers : 'N/A';
    //         item.cumulative_total_records = item.cumulative_total_records ? item.cumulative_total_records : 'N/A';
    //         item.title_priority = item.title_priority ? item.title_priority : 'N/A';
    //         item.torrent_priority = item.torrent_priority ? item.torrent_priority : 'N/A';
    //         item.torrent_available = item.torrent_available ? item.torrent_available : 'N/A';
    //         item.release_year = item.release_year ? item.release_year : 'N/A';
    //
    //         item.last_allocated_time = item.last_allocated_time ? new Date(item.last_allocated_time).toISOString().slice(0, 10) : '0000-00-00';
    //         item.discovery_time = item.discovery_time ? new Date(item.discovery_time).toISOString().slice(0, 10) : '0000-00-00';
    //         item.updated_time = item.updated_time ? new Date(item.updated_time).toISOString().slice(0, 10) : '0000-00-00';
    //         item.last_searched_time = item.last_searched_time ? new Date(item.last_searched_time).toISOString().slice(0, 10) : '0000-00-00';
    //         item.tracked_on = item.tracked_on ? new Date(item.tracked_on).toISOString().slice(0, 10) : '0000-00-00';
    //
    //         if (item.human_verified) {
    //             item.humanVerifiedText = 'Yes';
    //             this.humanVerifiedCheck = true;
    //         } else {
    //             item.humanVerifiedText = 'No';
    //         }
    //         if (item.system_verified) {
    //             item.systemVerifiedText = 'Yes';
    //             this.systemVerifiedCheck = true;
    //
    //         } else {
    //             item.systemVerifiedText = 'No';
    //         }
    //         if (item.torrent_available) {
    //             item.torrent_available = 'Yes';
    //             this.torrentAvailableCheck = true;
    //
    //         } else {
    //             item.torrent_available = 'No';
    //         }
    //
    //         return item;
    //     });
    // }

    infohashBatchSearch() {
        this.bulkInfohashService.getInfohashBatch(this.userDetailsService.getUsername())
            .then(res => {
                this.infohashGetESDetails(res.results);
            })
            .catch((err) => {
                console.error('Error searching for infohashes: ', err.toString());
                this.loadingInfohashes = false;
            });
    }

    infohashGetESDetails(cumulativeTorrentRecords: any[]) {
        const parrotIdMatchArray = [];
        cumulativeTorrentRecords.forEach((item) => {
            if (item.currentParrotId) {
                parrotIdMatchArray.push({
                    match: {
                        parrot_id: item.currentParrotId
                    }
                });
            }
        });
        const elasticSearchQuery = {
            'query': {
                'bool': {
                    'must': {
                        'bool': {
                            'should': parrotIdMatchArray
                        }
                    }
                }
            },
            '_source': ['parrot_id', 'title', 'data.release_year', 'data.original_country'],
            'size': parrotIdMatchArray.length,
            'min_score': 30
        };
        this.catalogService.callEsProxyCustomQuery(JSON.stringify(elasticSearchQuery), 'master_catalog')
            .then((res) => {
                const elasticSearchRes = res.hits.hits;
                this.tableData = cumulativeTorrentRecords.map((item) => {
                    const elasticSearchCurrentTitleObject = elasticSearchRes.filter((item2) => {
                        return item.currentParrotId === item2._source.parrot_id;
                    })[0];
                    item.latestDate = new Date(item.latestDate).toISOString().slice(0, 10);
                    item.dateDiscovered = new Date(item.dateDiscovered).toISOString().slice(0, 10);
                    if (elasticSearchCurrentTitleObject) {
                        item.currentTitle = elasticSearchCurrentTitleObject._source.title;
                        if (elasticSearchCurrentTitleObject._source.data) {
                            if (elasticSearchCurrentTitleObject._source.data.release_year) {
                                item.currentTitle = item.currentTitle + ' - ' + elasticSearchCurrentTitleObject._source.data.release_year;
                            }
                            if (elasticSearchCurrentTitleObject._source.data.original_country) {
                                item.currentTitle = item.currentTitle + ' - ' + elasticSearchCurrentTitleObject._source.data.original_country['0'];
                            }
                        }
                    }
                    if (item.humanVerified === 0) {
                        item.humanVerifiedText = 'No';
                    } else if (item.humanVerified === 1) {
                        item.humanVerifiedText = 'Yes';
                    } else if (item.humanVerified === 2) {
                        item.humanVerifiedText = 'Pending';
                    }
                    return item;
                });
                if (this.tableData.length === 0) {
                    this.toasterService.pop('info', 'No infohashes were found');
                }
                this.loadingInfohashes = false;
            });
    }

    pendingInfohashSearch() {
        this.bulkInfohashService.getPendingInfohashMappings(PAGE_SIZE, this.page, this.orderBy, this.orderDirection)
            .then((res) => {
                this.maxPages = res.pageinfo.maxpage ? res.pageinfo.maxpage : 1;
                if (res.pageinfo.totalitems > 0) {
                    this.pendingInfohashGetESDetails(res.mappingUpdates);
                } else {
                    // No pending mappings.
                    this.toasterService.pop('info', 'There are no pending mappings!');
                    this.loadingInfohashes = false;
                }
            })
            .catch((err) => {
                console.error('Error searching for pending infohashes: ', err.toString());
                this.loadingInfohashes = false;
            });
    }

    pendingInfohashBatchSearch() {
        this.bulkInfohashService.getPendingInfohashBatch(this.userDetailsService.getUsername())
            .then(res => {
                if (res.mappingUpdates.length > 0) {
                    this.pendingInfohashGetESDetails(res.mappingUpdates);
                } else {
                    // No pending mappings.
                    this.toasterService.pop('info', 'There are no pending mappings!');
                    this.loadingInfohashes = false;
                }
            })
            .catch((err) => {
                console.error('Error searching for pending infohashes: ', err.toString());
                this.loadingInfohashes = false;
            });
    }

    pendingInfohashGetESDetails(mappingUpdates: any[]) {
        const infohashArray = mappingUpdates.map((item) => item.mapping_value);
        const parrotIdMatchArray = [];
        const addedIds = [];
        mappingUpdates.forEach((item) => {
            const titleIdMatch = {
                match: {
                    parrot_id: item.title_id
                }
            };
            const newMappingMatch = {
                match: {
                    parrot_id: item.new_mapping
                }
            };
            if (!addedIds.includes(item.title_id) && item.title_id) {
                parrotIdMatchArray.push(titleIdMatch);
                addedIds.push(item.title_id);
            }
            if (!addedIds.includes(item.new_mapping) && item.new_mapping) {
                parrotIdMatchArray.push(newMappingMatch);
                addedIds.push(item.new_mapping);
            }
        });
        const elasticSearchQuery = {
            'query': {
                'bool': {
                    'must': {
                        'bool': {
                            'should': parrotIdMatchArray
                        }
                    }
                }
            },
            '_source': ['parrot_id', 'title', 'display_name', 'data.original_country', 'data.release_year'],
            'size': parrotIdMatchArray.length,
            'min_score': 30
        };

        Promise.all([this.bulkInfohashService.getPendingCumulativeTorrents(infohashArray),
            this.catalogService.callEsProxyCustomQuery(JSON.stringify(elasticSearchQuery), 'master_catalog')])
            .then((resArray) => {
                const pendingCumulativeTorrentsRes = resArray[0];
                const elasticSearchRes = resArray[1].hits.hits;
                this.tableData = mappingUpdates.map((item1) => {
                    // Find the mapping request object, the new title ES object, and the old title ES object.
                    const infohashObject = pendingCumulativeTorrentsRes.results.filter((item2) => {
                        return item1.mapping_value === item2.infohash;
                    })[0];
                    const elasticSearchNewTitleObject = elasticSearchRes.filter((item2) => {
                        return item1.new_mapping === item2._source.parrot_id;
                    })[0];
                    const elasticSearchCurrentTitleObject = elasticSearchRes.filter((item2) => {
                        return item1.title_id === item2._source.parrot_id;
                    })[0];

                    // Safely extract the country from the ES objects
                    const originalCountryCurrent = elasticSearchCurrentTitleObject &&
                    elasticSearchCurrentTitleObject._source.data &&
                    elasticSearchCurrentTitleObject._source.data.original_country &&
                    elasticSearchCurrentTitleObject._source.data.original_country['0'] ?
                        elasticSearchCurrentTitleObject._source.data.original_country['0'] : '';
                    const originalCountryNew = elasticSearchNewTitleObject &&
                    elasticSearchNewTitleObject._source.data &&
                    elasticSearchNewTitleObject._source.data.original_country &&
                    elasticSearchNewTitleObject._source.data.original_country['0'] ?
                        elasticSearchNewTitleObject._source.data.original_country['0'] : '';

                    // Create the text for the title
                    const currentTitle = elasticSearchCurrentTitleObject ?
                        [
                            `${elasticSearchCurrentTitleObject._source.display_name}`,
                            `${originalCountryCurrent}`,
                            `${elasticSearchCurrentTitleObject._source.data ?
                                elasticSearchCurrentTitleObject._source.data.release_year : ''}`
                        ].filter(item => item).join(' - ')
                        : undefined;
                    const newTitle = elasticSearchNewTitleObject ?
                        [
                            `${elasticSearchNewTitleObject._source.display_name}`,
                            `${originalCountryNew}`,
                            `${elasticSearchNewTitleObject._source.data ?
                                elasticSearchNewTitleObject._source.data.release_year : ''}`
                        ].filter(item => item).join(' - ')
                        : undefined;

                    return {
                        infohash: item1.mapping_value,
                        idMappingRequest: item1.idMappingRequest,
                        latestDate: infohashObject ? infohashObject.latestDate : '',
                        dateDiscovered: infohashObject ? infohashObject.dateDiscovered : '',
                        torrentName: infohashObject ? infohashObject.torrentName : '',
                        localTitle: infohashObject ? infohashObject.localTitle : '',
                        currentTitle: currentTitle,
                        newTitle: newTitle,
                        newTitleId: item1.new_mapping
                    };
                })
                    .sort((a, b) => {
                        if (a.localTitle < b.localTitle) {
                            return -1;
                        }
                        if (a.localTitle > b.localTitle) {
                            return 1;
                        }
                        return 0;
                    });
                ;
                this.loadingInfohashes = false;
            })
            .catch((err) => {
                console.error('Error searching for pending infohashes: ', err.toString());
                this.loadingInfohashes = false;
            });
    }

    searchInfohashes() {
        this.loadingInfohashes = true;
        this.selectAll = false;
        this.tableData = undefined;
        if (!this.adminMode) {
            if (this.advancedMode) {
                this.infohashSearch();
            } else {
                this.infohashBatchSearch();
            }
        } else {
            if (this.advancedMode) {
                this.pendingInfohashSearch();
            } else {
                this.pendingInfohashBatchSearch();
            }
        }
    }
    handleTableRowClick(data: any) {
        data.collapsed = !data.collapsed;
    }

    handleParrotIdTableRowClick(parrotId: any) {
        parrotId.collapsed = !parrotId.collapsed;
        // console.log(parrotId.collapsed);
    }

    handleCategoryStateCheckbox(checkboxName, checked: any) {

        this.categoryValue = [];

        if (checked) {
            this.categoryValue.push(checkboxName);
        }
    }

    handleSpecialCheckbox(checkboxName: string, checked: any) {


        this.smartGroupingCheckBox = false;
        this.parrotIDOnlyCheckBox = false;
        this.demandOnlyCheckBox = false;

        if( checkboxName === 'smartGrouped' ){
            this.smartGroupingCheckBox = true;

        }if( checkboxName === 'parrotIDOnly' ){
            this.parrotIDOnlyCheckBox = true;

        }if( checkboxName === 'demandOnly' ){
            this.demandOnlyCheckBox = true;

        }

    }

    handleHumanVerifiedStateCheckbox(checkboxName: boolean, checked: any) {
        this.humanVerfied = [];

        if (checked) {
            this.humanVerfied.push(checkboxName);
        }
    }

    handleSystemVerifiedStateCheckbox(checkboxName: boolean, checked: any) {
        this.systemVerfied = [];

        if (checked) {
            this.systemVerfied.push(checkboxName);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bulk-infohash/bulk-infohash.component.ts